import React from 'react';

const MIMessage = ({configurable}) => {
    return (
        <div className={"MIMessage"}>
            {configurable.contenu}
        </div>
    );
};

export default MIMessage;